export default __webpack_public_path__ + "static/189-0b812d8c5d10de52a6187ecd3c684910.jpg";